import axios from "axios"
import Joi from "joi"

import { type APIError } from "@interfaces/APIError.interface"
import { useErrorStore } from "@stores/models/error.store"

export function handleError(error: unknown): APIError {
  if (axios.isAxiosError(error)) {
    const responseError = error.response
    if (responseError) {
      const responseSchema = Joi.object({
        error: Joi.string().required()
      })

      const { error, value } = responseSchema.validate(responseError.data)
      if (error) {
        const errorStore = useErrorStore()
        errorStore.showIntegrityError()
        return { error: "Communication integrity error" }
      }

      if (value.error === "Unauthorized") return { error: "Acces interzis!" }

      return { error: value.error }
    } else {
      return { error: "Verifică conexiunea la internet!" }
    }
  }

  if (error instanceof Error) {
    return { error: error.message || "An error occurred" }
  }

  return { error: "Unknown error occurred" }
}
